import script from "./Password.vue?vue&type=script&setup=true&lang=ts"
export * from "./Password.vue?vue&type=script&setup=true&lang=ts"

import "./Password.vue?vue&type=style&index=0&id=bed75b6c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bed75b6c"]])

export default __exports__